import type { FieldKind, SignField, SignParty } from "../types";
import { fieldLabel, partyName } from "./palette";

export function fieldsForParty(fields: SignField[], partyId: number): SignField[] {
  const mine = fields.filter((f) => !f.party_id || f.party_id === partyId);
  return mine;
}

export function signerNameFromVals(fields: SignField[], vals: Record<number, string>, fallback: string): string {
  const byKind = fields.find((f) => f.kind === "name" && f.id);
  if (byKind?.id && (vals[byKind.id] || "").trim().length >= 3) return vals[byKind.id].trim();
  const labeled = fields.find((f) => f.id && /nom/i.test(f.label || "") && (vals[f.id] || "").trim().length >= 3);
  if (labeled?.id) return vals[labeled.id].trim();
  const text = fields.find((f) => f.kind === "text" && f.id && (vals[f.id] || "").trim().length >= 3);
  if (text?.id) return vals[text.id].trim();
  return fallback.trim();
}

export function previewTitle(field: SignField): string {
  return field.label?.trim() || fieldLabel(field.kind);
}

export function previewAction(kind: FieldKind, last: boolean): string {
  if (kind === "signature") return "Signer";
  if (kind === "stamp") return "Tamponner";
  if (kind === "paraphe") return "Parapher";
  if (kind === "check" || kind === "radio") return "Cocher";
  return last ? "Terminer" : "Suivant";
}

export function previewFilled(kind: FieldKind, value: string): boolean {
  if (kind === "check" || kind === "radio") return value === "1" || value === "✓";
  if (kind === "paraphe") return /^[A-Za-zÀ-ÿ]{2}$/.test(value.trim());
  if (kind === "signature") return value.startsWith("data:image");
  return value.trim().length > 0;
}

export function previewMark(kind: FieldKind, value: string): string {
  if (!previewFilled(kind, value)) return "";
  if (kind === "check" || kind === "radio") return "✓";
  if (kind === "signature") return value;
  return value;
}

export function previewApply(field: SignField, raw: string, parties: SignParty[]): string {
  const kind = field.kind;
  const v = raw.trim();
  if (kind === "check" || kind === "radio") return v ? "" : "✓";
  if (kind === "date") return v || new Date().toLocaleDateString("fr-FR");
  if (kind === "stamp") return v || partyName(parties, field.party_id);
  if (kind === "paraphe") return v.replace(/[^A-Za-zÀ-ÿ]/g, "").slice(0, 2).toUpperCase();
  if (kind === "signature") return v.startsWith("data:image") ? v : "";
  return v;
}

export function todayInput(): string {
  const d = new Date();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${d.getFullYear()}-${m}-${day}`;
}

export function frDate(iso: string): string {
  const [y, m, d] = iso.split("-");
  return y && m && d ? `${d}/${m}/${y}` : iso;
}

export function toIso(fr: string): string {
  const m = fr.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  return m ? `${m[3]}-${m[2]}-${m[1]}` : "";
}
